import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputNumbersmall, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { cuttingReturnEntry, fetchCutReturnMemo, fetchCuttingList, fetchCuttingMemoWise } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { selectCuttingMemoWise } from '../Selectors/Master/ItemSelectors';
import { useParams } from 'react-router-dom';
import { errorStyles } from '../../Utils/table';
import Dropdown from '../FieldsComponents/Dropdown';
import CircularProgress from '@mui/material/CircularProgress';


const CuttingInward2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        cutId: '',
        dt: '',
        reMemo: '',
        cutMemo: '',
        sono: '',
        soId: '',
        empNm: '',
        empType: '1',
        item: '',
        itemId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        mgmtr: '',
        m1gmtr: '',
        m2gmtr: '',
        m3gmtr: '',
        mRmtr: '',
        m1Rmtr: '',
        m2Rmtr: '',
        m3Rmtr: '',
        mused: '0',
        m1used: '0',
        m2used: '0',
        m3used: '0',
        totQty: '0',
        reQty: '0',
        userId: userdata?.ID,
        remainqtyy: '0'
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    // const cuttingdatalist = useSelector(selectCuttingDatalist);
    // const cutRememo = useSelector(selectCutReturnMemo);

    const cuttingdatalist = useSelector(selectCuttingMemoWise);
    // console.log(cuttingdatalist)

    const [itemdata, setItemdata] = useState([]);
    const [cutdata, setCutdata] = useState([]);
    const [itemData, setItemData] = useState([]);

    const [extraQtyValues, setExtraQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [returnQtyValues, setReturnQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [damageQtyValues, setDamageQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [mainAvg, setMainAvg] = useState(Array(itemData?.size?.length).fill(''));
    const [m1Avg, setM1Avg] = useState(Array(itemData?.size?.length).fill(''));
    const [m2Avg, setM2Avg] = useState(Array(itemData?.size?.length).fill(''));
    const [m3Avg, setM3Avg] = useState(Array(itemData?.size?.length).fill(''));

    useEffect(() => {
        dispatch(fetchCuttingMemoWise(Id));
    }, [dispatch, Id]);


    useEffect(() => {
        if (cuttingdatalist?.itemlist?.length > 0) {
            const values = cuttingdatalist?.itemlist;

            setItemdata(values);
        }
        if (cuttingdatalist?.data) {
            const datas = cuttingdatalist?.data;
            setCutdata(datas);
        }
    }, [cuttingdatalist]);

    useEffect(() => {
        if (returnQtyValues.length > 0) {
            const reqtytotal = returnQtyValues?.reduce((sum, qty) => sum + parseFloat(qty), 0);

            setFormData(prev => ({
                ...prev,
                reQty: reqtytotal || 0,
            }));
        }

    }, [returnQtyValues]);


    // useEffect to update mused whenever returnQtyValues changes
    useEffect(() => {
        if (returnQtyValues.length > 0) {
            const newMusedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const mavg = itemData.mavg !== undefined ? parseFloat(itemData.mavg[index] || 0) : 0;
                return returnQty * mavg;
            });
            const newM1usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m1avg = itemData.m1avg !== undefined ? parseFloat(itemData.m1avg[index] || 0) : 0;
                return returnQty * m1avg;
            });

            const newM2usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m2avg = itemData.m2avg !== undefined ? parseFloat(itemData.m2avg[index] || 0) : 0;
                return returnQty * m2avg;
            });

            const newM3usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m3avg = itemData.m3avg !== undefined ? parseFloat(itemData.m3avg[index] || 0) : 0;
                return returnQty * m3avg;
            });

            const totalMused = newMusedValues?.reduce((sum, num) => sum + num, 0) || 0;
            const totalM1used = newM1usedValues?.reduce((sum, num) => sum + num, 0) || 0;
            const totalM2used = newM2usedValues?.reduce((sum, num) => sum + num, 0) || 0;
            const totalM3used = newM3usedValues?.reduce((sum, num) => sum + num, 0) || 0;

            const mr = parseFloat(formData.mgmtr) - totalMused || 0;
            const m1r = parseFloat(formData.m1gmtr) - totalM1used || 0;
            const m2r = parseFloat(formData.m2gmtr) - totalM2used || 0;
            const m3r = parseFloat(formData.m3gmtr) - totalM3used || 0;
            setFormData((prev) => ({
                ...prev,
                mused: totalMused.toFixed(2) || 0, // Update mused automatically
                m1used: totalM1used.toFixed(2) || 0,
                m2used: totalM2used.toFixed(2) || 0,
                m3used: totalM3used.toFixed(2) || 0,
                mRmtr: mr.toFixed(2) || 0,
                m1Rmtr: m1r.toFixed(2) || 0,
                m2Rmtr: m2r.toFixed(2) || 0,
                m3Rmtr: m3r.toFixed(2) || 0
            }));
        }
    }, [returnQtyValues, itemData]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'itemId':
                if (value) {
                    const selectdata = cutdata?.find(item => item.itemId === value);
                    // console.log(selectdata);
                    if (selectdata) {
                        const returncount = parseFloat(selectdata.count) + 1;

                        const item = selectdata?.cloths[0];
                        const musedmtr = parseFloat(item.mused) || 0;
                        const m1usedmtr = parseFloat(item.m1used) || 0;
                        const m2usedmtr = parseFloat(item.m2used) || 0;
                        const m3usedmtr = parseFloat(item.m3used) || 0;
                        const remainqty = selectdata?.cutRedata?.rqty ? parseFloat(selectdata.totQty) - parseFloat(selectdata?.cutRedata?.rqty) : selectdata.totQty;
                        setFormData(prev => ({
                            ...prev,
                            empNm: selectdata.empNm,
                            empId: selectdata.empId,
                            empType: selectdata.empType,
                            item: selectdata.itemNm,
                            itemId: selectdata.itemId,
                            cutMemo: selectdata.memoNo,
                            reMemo: returncount !== 1 ? `R-${selectdata.memoNo}-${returncount}` : `R-${selectdata.memoNo}-1`,
                            soId: selectdata.soId,
                            sono: selectdata.sono,
                            totQty: selectdata.totQty,
                            mcloth: item.mcloth,
                            mclothNm: item.mclothNm,
                            m1cloth: item.m1cloth,
                            m1clothNm: item.m1clothNm,
                            m2cloth: item.m2cloth,
                            m2clothNm: item.m2clothNm,
                            m3cloth: item.m3cloth,
                            m3clothNm: item.m3clothNm,
                            mgmtr: (parseFloat(item.mgmtr) - musedmtr).toFixed(2),
                            m1gmtr: (parseFloat(item.m1gmtr) - m1usedmtr).toFixed(2),
                            m2gmtr: (parseFloat(item.m2gmtr) - m2usedmtr).toFixed(2),
                            m3gmtr: (parseFloat(item.m3gmtr) - m3usedmtr).toFixed(2),
                            cutId: selectdata.ID,
                            remainqtyy: remainqty,
                            mRmtr: (parseFloat(item.mreq) - musedmtr).toFixed(2),
                            m1Rmtr: (parseFloat(item.m1req) - m1usedmtr).toFixed(2),
                            m2Rmtr: (parseFloat(item.m2req) - m2usedmtr).toFixed(2),
                            m3Rmtr: (parseFloat(item.m3req) - m3usedmtr).toFixed(2),
                            mreq: (parseFloat(item.mreq) - musedmtr).toFixed(2),
                            m1req: (parseFloat(item.m1req) - m1usedmtr).toFixed(2),
                            m2req: (parseFloat(item.m2req) - m2usedmtr).toFixed(2),
                            m3req: (parseFloat(item.m3req) - m3usedmtr).toFixed(2),
                        }));

                        const array = selectdata?.cutInfo?.length > 0 ? {
                            size: selectdata?.cutInfo?.map(val => val.size),
                            mavg: selectdata?.cutInfo?.map(val => parseFloat(val.mavg)),
                            m1avg: selectdata?.cutInfo?.map(val => parseFloat(val.m1avg)),
                            m2avg: selectdata?.cutInfo?.map(val => parseFloat(val.m2avg)),
                            m3avg: selectdata?.cutInfo?.map(val => parseFloat(val.m3avg)),
                            qty: selectdata?.cutInfo?.map(val => parseFloat(val.balqty)),
                            rqty: selectdata?.cutInfo?.map(() => 0),
                            dqty: selectdata?.cutInfo?.map(() => 0),
                            eqty: selectdata?.cutInfo?.map(() => 0),
                            bqty: selectdata?.cutInfo?.map(val => parseFloat(val.balqty)),
                            // soqty: selectdata?.cutInfo.map(val => parseFloat(val.soqty))
                        } : [];
                        // console.log(array);
                        setItemData(array);
                    }
                } else {
                    setFormData(prev => ({
                        ...prev,
                        empNm: '',
                        empId: '',
                        empType: '',
                        item: '',
                        itemId: '',
                        cutMemo: '',
                        reMemo: '',
                        soId: '',
                        sono: '',
                        totQty: '',
                        mcloth: '',
                        mclothNm: '',
                        m1cloth: '',
                        m1clothNm: '',
                        m2cloth: '',
                        m2clothNm: '',
                        m3cloth: '',
                        m3clothNm: '',
                        mgmtr: '',
                        m1gmtr: '',
                        m2gmtr: '',
                        m3gmtr: '',
                        remainqtyy: '',
                        mRmtr: '',
                        m1Rmtr: '',
                        m2Rmtr: '',
                        m3Rmtr: '',
                        mreq: '',
                        m1req: '',
                        m2req: '',
                        m3req: ""
                    }));
                }
                break;
            default:
                break;
        }
    };

    const handleQtyChange = (type, index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            let updatedValues;
            switch (type) {
                case 'return':
                    updatedValues = [...returnQtyValues];
                    updatedValues[index] = value;
                    setReturnQtyValues(updatedValues);

                    if (value > itemData.qty[index]) {
                        // Case 2: returnQty > cuttingQty
                        let extraQty = [...extraQtyValues];
                        extraQty[index] = value - itemData.qty[index];
                        setExtraQtyValues(extraQty);
                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = 0; // If returnQty > cuttingQty, balQty is 0
                            return balQty;
                        });
                    } else {
                        // Case 1: returnQty <= cuttingQty
                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = itemData.qty[index] - value;
                            return balQty;
                        });
                        setExtraQtyValues(prev => {
                            let extraQty = [...prev];
                            extraQty[index] = 0; // If returnQty <= cuttingQty, extraQty is 0
                            return extraQty;
                        });
                    }
                    let main_avg = [...mainAvg];
                    let singleUsed = parseFloat(itemData.qty[index]) * parseFloat(itemData.mavg[index]);
                    let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(value);
                    main_avg[index] = mact_avg.toFixed(2);
                    setMainAvg(main_avg);

                    let m1_avg = [...m1Avg];
                    let m1single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m1avg[index]);
                    let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(value);
                    m1_avg[index] = m1actual_avg.toFixed(2);
                    setM1Avg(m1_avg);

                    let m2_avg = [...m2Avg];
                    let m2single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m2avg[index]);
                    let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(value);
                    m2_avg[index] = m2actual_avg.toFixed(2);
                    setM2Avg(m2_avg);

                    let m3_avg = [...m3Avg];
                    let m3single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m3avg[index]);
                    let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(value);
                    m3_avg[index] = m3actual_avg.toFixed(2);
                    setM3Avg(m3_avg);


                    break;

                case 'damage':
                    updatedValues = [...damageQtyValues];
                    updatedValues[index] = value;
                    setDamageQtyValues(updatedValues);

                    // Adjusting the `returnQty` when `damageQty` is entered
                    let currentReturnQty = returnQtyValues[index] || 0;
                    let damageQty = parseInt(value) || 0;
                    let cuttingQty = itemData.qty[index];

                    if (currentReturnQty >= cuttingQty) {
                        // Case when returnQty is already greater than cuttingQty
                        let extraQty = [...extraQtyValues];
                        let excessReturn = currentReturnQty - damageQty - cuttingQty;
                        extraQty[index] = excessReturn >= 0 ? excessReturn : 0; // Handle extraQty
                        setExtraQtyValues(extraQty);

                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = 0; // BalQty is zero when returnQty > cuttingQty
                            return balQty;
                        });
                        let returnQty = [...returnQtyValues];
                        let updatereturn = currentReturnQty - damageQty;
                        returnQty[index] = updatereturn >= 0 ? updatereturn : 0;
                        setReturnQtyValues(returnQty);

                        let main_avg = [...mainAvg];
                        let singleUsed = parseFloat(itemData.qty[index]) * parseFloat(itemData.mavg[index]);
                        let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(returnQty[index]);
                        main_avg[index] = mact_avg.toFixed(2);
                        setMainAvg(main_avg);

                        let m1_avg = [...m1Avg];
                        let m1single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m1avg[index]);
                        let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(returnQty[index]);
                        m1_avg[index] = m1actual_avg.toFixed(2);
                        setM1Avg(m1_avg);

                        let m2_avg = [...m2Avg];
                        let m2single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m2avg[index]);
                        let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(returnQty[index]);
                        m2_avg[index] = m2actual_avg.toFixed(2);
                        setM2Avg(m2_avg);

                        let m3_avg = [...m3Avg];
                        let m3single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m3avg[index]);
                        let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(returnQty[index]);
                        m3_avg[index] = m3actual_avg.toFixed(2);
                        setM3Avg(m3_avg);

                    } else {
                        // Normal case: when returnQty <= cuttingQty
                        let remainingQty = cuttingQty - currentReturnQty;
                        let balQty = remainingQty - damageQty;

                        setBalQtyValues(prev => {
                            let newBalQty = [...prev];
                            newBalQty[index] = balQty >= 0 ? balQty : 0; // Ensure no negative balQty
                            return newBalQty;
                        });

                        setExtraQtyValues(prev => {
                            let newExtraQty = [...prev];
                            newExtraQty[index] = 0; // ExtraQty is 0 when returnQty <= cuttingQty
                            return newExtraQty;
                        });
                    }



                    break;

                default:
                    break;
            }

        }
    };

    const fields = [
        { label: 'Cutting Memo', name: 'cutMemo' },
        { label: 'Master', name: 'empNm' }
    ];

    const fields2 = [
        { label: 'Main Cloth', name: 'mclothNm' }
    ];

    function convertIntoOneObject(formData, itemData, extraQtyValues, returnQtyValues, damageQtyValues, balQtyValues, mainAvg, m1Avg, m2Avg, m3Avg) {
        const data = {
            dt: formData.dt,
            reMemo: formData.reMemo,
            cutMemo: formData.cutMemo,
            empId: formData.empId,
            empType: formData.empType,
            cutId: formData.cutId,
            itemId: formData.itemId,
            soId: formData.soId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth || '0',
            m2cloth: formData.m2cloth || '0',
            m3cloth: formData.m3cloth || '0',
            mused: formData.mused,
            m1used: formData.m1used || '0',
            m2used: formData.m2used || '0',
            m3used: formData.m3used || '0',
            totQty: formData.totQty || '0',
            reQty: formData.reQty || '0',
            size: itemData.size,
            mavg: mainAvg,
            m1avg: m1Avg,
            m2avg: m2Avg,
            m3avg: m3Avg,
            cqty: itemData.qty,
            // eqty: extraQtyValues,
            // rqty: returnQtyValues,
            // dqty: damageQtyValues,
            // balqty: balQtyValues,
            eqty: itemData.eqty,
            rqty: itemData.rqty,
            dqty: itemData.dqty,
            balqty: itemData.bqty,
            userId: formData.userId,
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!formData.dt || formData.dt.trim() === '') {
            alert("Date is required.");
            return; // Stop the submission if validation fails
        }

        if (!formData.itemId) {
            alert("Item is required.");
            return; // Stop the submission if validation fails
        }

        setLoading(true);

        try {

            const finalObject = convertIntoOneObject(formData, itemData, extraQtyValues, returnQtyValues, damageQtyValues, balQtyValues, mainAvg, m1Avg, m2Avg, m3Avg);
            // console.log(finalObject)

            const result = await dispatch(cuttingReturnEntry(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Cutting Return Added");
            alert("Cutting Return Added");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };



    const dropdownlist = [
        {
            label: 'Item',
            id: 'itemId',
            options: itemdata || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const handleQtyChanged = (type, index, value) => {
        if (!/^\d*$/.test(value)) return; // only numbers

        let numValue = Number(value);

        // let sizes = [...itemData.size];
        let qty = [...itemData.qty];
        let rqty = [...itemData.rqty];
        let dqty = [...itemData.dqty];
        let eqty = [...itemData.eqty];
        let bqty = [...itemData.bqty];
        let mavg = [...itemData.mavg];
        let m1avg = [...itemData.m1avg];
        let m2avg = [...itemData.m2avg];
        let m3avg = [...itemData.m3avg];

        if (type === 'rqty') {
            rqty[index] = numValue;

            //rqty > ctqty
            if (numValue > parseFloat(qty[index])) {
                eqty[index] = numValue - parseFloat(qty[index]);
                bqty[index] = 0;
            } else {
                // rqty <= ctqty
                bqty[index] = parseFloat(qty[index]) - numValue;
                eqty[index] = 0;
            }

            let main_avg = [...mainAvg];
            let singleUsed = parseFloat(qty[index]) * parseFloat(mavg[index]);
            let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(value);
            main_avg[index] = mact_avg.toFixed(2);
            setMainAvg(main_avg);

            let m1_avg = [...m1Avg];
            let m1single = parseFloat(qty[index]) * parseFloat(m1avg[index]);
            let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(value);
            m1_avg[index] = m1actual_avg.toFixed(2);
            setM1Avg(m1_avg);

            let m2_avg = [...m2Avg];
            let m2single = parseFloat(qty[index]) * parseFloat(m2avg[index]);
            let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(value);
            m2_avg[index] = m2actual_avg.toFixed(2);
            setM2Avg(m2_avg);

            let m3_avg = [...m3Avg];
            let m3single = parseFloat(qty[index]) * parseFloat(m3avg[index]);
            let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(value);
            m3_avg[index] = m3actual_avg.toFixed(2);
            setM3Avg(m3_avg);
        }

        if (type === 'dqty') {
            dqty[index] = numValue;
            let currentRqty = rqty[index];
            let cuttingQty = qty[index];

            if (currentRqty >= cuttingQty) {
                let excessReturn = parseFloat(currentRqty) - parseFloat(numValue) - parseFloat(cuttingQty);
                eqty[index] = excessReturn >= 0 ? excessReturn : 0;
                bqty[index] = 0;

                let updaterqty = parseFloat(currentRqty) - parseFloat(numValue);
                rqty[index] = updaterqty >= 0 ? updaterqty : 0;


                let main_avg = [...mainAvg];
                let singleUsed = parseFloat(qty[index]) * parseFloat(mavg[index]);
                let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(rqty[index]);
                main_avg[index] = mact_avg.toFixed(2);
                setMainAvg(main_avg);

                let m1_avg = [...m1Avg];
                let m1single = parseFloat(qty[index]) * parseFloat(m1avg[index]);
                let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(rqty[index]);
                m1_avg[index] = m1actual_avg.toFixed(2);
                setM1Avg(m1_avg);

                let m2_avg = [...m2Avg];
                let m2single = parseFloat(qty[index]) * parseFloat(m2avg[index]);
                let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(rqty[index]);
                m2_avg[index] = m2actual_avg.toFixed(2);
                setM2Avg(m2_avg);

                let m3_avg = [...m3Avg];
                let m3single = parseFloat(qty[index]) * parseFloat(m3avg[index]);
                let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(rqty[index]);
                m3_avg[index] = m3actual_avg.toFixed(2);
                setM3Avg(m3_avg);

            } else {
                let balqty = parseFloat(cuttingQty) - parseFloat(currentRqty) - parseFloat(numValue);
                bqty[index] = balqty >= 0 ? balqty : 0;
                eqty[index] = 0;

            }
        }
        setItemData(prev => ({
            ...prev,
            rqty,
            dqty,
            eqty,
            bqty
        }));
        setReturnQtyValues(rqty);
    };


    return (
        <>

            <div style={{ margin: '1% 1%' }}>
                <h2>Cutting Return Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Return Memo', name: 'reMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdownlist && dropdownlist.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }


                                <table>
                                    <tbody>
                                        <tr>
                                            <td>SO No.</td>
                                            <td>{formData.sono || ''}</td>

                                            <td>Cutting Memo</td>
                                            <td>{formData.cutMemo}</td>
                                        </tr>
                                        <tr>
                                            <td>Employee</td>
                                            <td>{formData.empNm}</td>
                                            <td>Issue Qty.</td>
                                            <td>{formData.totQty}</td>
                                        </tr>
                                        <tr>
                                            <td>Bal. Qty.</td>
                                            <td>{formData.remainqtyy}</td>
                                            <td>Return Qty.</td>
                                            <td>{formData.reQty}</td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table>
                                    <thead className='tbl-row'>
                                        <th>Type</th>
                                        <th>Cloth</th>
                                        <th>Given Mtr</th>
                                        <th>Req. Mtr</th>
                                        <th>Used Mtr</th>
                                        <th>Bal. Mtr</th>

                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>Main</td>
                                            <td>{formData.mclothNm}</td>
                                            <td>{formData.mgmtr}</td>
                                            <td>{formData.mreq}</td>
                                            <td>{formData.mused}</td>
                                            <td>{formData.mRmtr}</td>
                                        </tr>

                                        {
                                            formData.m1cloth !== '0' &&
                                            <tr>
                                                <td>Matching-1</td>
                                                <td>{formData.m1clothNm}</td>
                                                <td>{formData.m1gmtr}</td>
                                                <td>{formData.m1req}</td>
                                                <td>{formData.m1used}</td>
                                                <td>{formData.m1Rmtr}</td>
                                            </tr>
                                        }

                                        {
                                            formData.m2cloth !== '0' &&
                                            <tr>
                                                <td>Matching-2</td>
                                                <td>{formData.m2clothNm}</td>
                                                <td>{formData.m2gmtr}</td>
                                                <td>{formData.m2req}</td>
                                                <td>{formData.m2used}</td>
                                                <td>{formData.m2Rmtr}</td>
                                            </tr>
                                        }

                                        {
                                            formData.m3cloth !== '0' &&
                                            <tr>
                                                <td>Matching-3</td>
                                                <td>{formData.m3clothNm}</td>
                                                <td>{formData.m3gmtr}</td>
                                                <td>{formData.m3req}</td>
                                                <td>{formData.m3used}</td>
                                                <td>{formData.m3Rmtr}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>


                                {itemData?.size?.length > 0 &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Cutting Qty.</TableCell>
                                                    {itemData.qty ? itemData.qty.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                        <>
                                                            Main Avg. <br /> <hr /> Main Actual Avg.
                                                        </>
                                                    </TableCell>
                                                    {itemData.mavg ? itemData.mavg.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <>
                                                                {val} <br /> <hr /> {!mainAvg[index] ? 0 : (val >= mainAvg[index] ? <p style={{ color: 'green' }}>{mainAvg[index]}</p> : <p style={{ color: 'red' }}>{mainAvg[index]}</p>)}
                                                            </>
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {formData.m1cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M1 Avg. <br /> <hr /> M1 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m1avg ? itemData.m1avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m1Avg[index] ? 0 : (val >= m1Avg[index] ? <p style={{ color: 'green' }}>{m1Avg[index]}</p> : <p style={{ color: 'red' }}>{m1Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {formData.m2cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M2 Avg. <br /> <hr /> M2 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m2avg ? itemData.m2avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m2Avg[index] ? 0 : (val >= m2Avg[index] ? <p style={{ color: 'green' }}>{m2Avg[index]}</p> : <p style={{ color: 'red' }}>{m2Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {formData.m3cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M3 Avg. <br /> <hr /> M3 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m3avg ? itemData.m3avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m3Avg[index] ? 0 : (val >= m3Avg[index] ? <p style={{ color: 'green' }}>{m3Avg[index]}</p> : <p style={{ color: 'red' }}>{m3Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {/* Return Qty Row */}
                                                {/* <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    {itemData.size ? itemData?.size?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={returnQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...returnQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setReturnQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('return', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow> */}

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    {itemData.rqty ? itemData?.rqty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={val}
                                                                onChange={(e) => handleQtyChanged("rqty", index, e.target.value)}

                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {/* Damage Qty Row */}
                                                {/* <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={damageQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...damageQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setDamageQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('damage', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow> */}

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                                    {itemData.dqty ? itemData?.dqty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={val}
                                                                onChange={(e) => handleQtyChanged("dqty", index, e.target.value)}

                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {/* <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Extra Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {extraQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow> */}

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Extra Qty.</TableCell>
                                                    {itemData.eqty ? itemData.eqty.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {val || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>



                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData.bqty ? itemData.bqty.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {val || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                {/* <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={returnQtyValues.length === 0}>Submit</Button>
                                </Grid> */}


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default CuttingInward2;
